import { render } from "./InspirationCard.vue?vue&type=template&id=3cbd94ae&scoped=true"
import script from "./InspirationCard.vue?vue&type=script&lang=js"
export * from "./InspirationCard.vue?vue&type=script&lang=js"

import "./InspirationCard.vue?vue&type=style&index=0&id=3cbd94ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbd94ae"]])

export default __exports__